import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated, getUserRole, hasPageAccess, getAllowedPages } from '../services/api';

const ProtectedRoute = ({ children, allowedRoles, requiredPage }) => {
  if (!isAuthenticated()) {
    // Redirect to login if not authenticated
    return <Navigate to="/login" replace />;
  }

  // If allowedRoles is specified, check if user has permission (legacy support)
  if (allowedRoles && allowedRoles.length > 0) {
    const userRole = getUserRole();
    if (!allowedRoles.includes(userRole)) {
      // Redirect to first allowed page
      const allowedPages = getAllowedPages();
      if (allowedPages.includes('all') || allowedPages.includes('dashboard')) {
        return <Navigate to="/dashboard" replace />;
      } else if (allowedPages.length > 0) {
        return <Navigate to={`/${allowedPages[0]}`} replace />;
      }
      return <Navigate to="/login" replace />;
    }
  }

  // If requiredPage is specified, check page-level access
  if (requiredPage && !hasPageAccess(requiredPage)) {
    // Redirect to first allowed page
    const allowedPages = getAllowedPages();
    if (allowedPages.includes('all') || allowedPages.includes('dashboard')) {
      return <Navigate to="/dashboard" replace />;
    } else if (allowedPages.length > 0) {
      return <Navigate to={`/${allowedPages[0]}`} replace />;
    }
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
